/* Product card sliders (v2.1 — init-once, scoped controls, tap-safe mobile swipe)
   - Guards against double-initialization (was re-initializing every
     card on each Load More / infinite scroll, leaking Swiper instances)
   - Arrows/pagination scoped to each card (were global selectors)
   - v2.1: mobile swipe no longer swallows taps. The old handler treated
     any touch with >10px horizontal drift as a "swipe" and called
     preventDefault on the click, cancelling navigation to the PDP — so a
     normal tap (thumb naturally rolls ~10-15px) had to be repeated 2-3
     times before the product page opened. The threshold is now higher,
     horizontal intent must clearly dominate vertical, and the click is
     only suppressed when a swipe actually changed the slide. */

if (typeof loadeMoreSlider_G === 'undefined') {
  globalThis.loadeMoreSlider_G = null;
}

(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll('.product-card-js');
    const isRtl = document.documentElement.getAttribute('dir') === 'rtl';

    sliders.forEach((slider) => {
      if (slider.swiper) return; /* already initialized — never double-init */

      const scope = slider.closest('.card__inner') || slider.parentElement || slider;
      let nextEl = scope.querySelector('.product-button-group .swiper-button-next');
      let prevEl = scope.querySelector('.product-button-group .swiper-button-prev');
      if (isRtl) {
        const t = nextEl;
        nextEl = prevEl;
        prevEl = t;
      }
      const paginationEl = scope.querySelector('.product-pagination .swiper-pagination');

      new Swiper(slider, {
        pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
        navigation: (nextEl || prevEl) ? { nextEl: nextEl, prevEl: prevEl } : undefined,
        allowTouchMove: true,
        breakpoints: {
          990: { allowTouchMove: false }
        },
        on: {
          slideChange: function () {
            const activeSlide = this.slides[this.activeIndex];
            if (!activeSlide) return;
            slider.querySelectorAll('video').forEach(function (v) {
              v.pause();
            });
            const video = activeSlide.querySelector('video');
            if (video) {
              video.muted = true;
              video.volume = 0;
              video.play().catch(function () {});
            }
          }
        }
      });
    });
  };

  initSlider();
  loadeMoreSlider_G = initSlider;
  document.addEventListener('shopify:section:load', function () {
    initSlider();
  });
})();

/* Mobile-only swipe for product card images (hover mode) */
(function () {
  // A real horizontal swipe must travel at least this far. A tap — even a
  // sloppy one where the thumb rolls a little — stays well under it, so taps
  // pass straight through to the PDP link.
  var SWIPE_THRESHOLD = 45;
  // During the gesture, only start treating it as a horizontal swipe once the
  // finger has moved clearly sideways AND clearly more sideways than vertical.
  var HORIZONTAL_INTENT = 24;

  function initMobileSwipe() {
    if (window.innerWidth >= 750) return;
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var overlay = card.querySelector('.card-wrapper__link--overlay');
      var swipeEl = card.querySelector('[data-mobile-swipe]');
      if (!overlay || !swipeEl) return;
      if (overlay._mobileSwipeInit) return;
      overlay._mobileSwipeInit = true;
      var slides = swipeEl.querySelectorAll('.card__mobile-swipe-slide');
      var dots = swipeEl.querySelectorAll('.card__mobile-swipe-dot');
      if (slides.length < 2) return;
      var current = 0;
      var startX = 0;
      var startY = 0;
      var didSwipe = false;   // a real swipe gesture is in progress
      var changedSlide = false; // a swipe actually advanced the slide
      function goTo(idx) {
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = idx;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }
      overlay.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        didSwipe = false;
        changedSlide = false;
      }, { passive: true });
      overlay.addEventListener('touchmove', function (e) {
        var dx = Math.abs(e.touches[0].clientX - startX);
        var dy = Math.abs(e.touches[0].clientY - startY);
        // Only claim the gesture as a horizontal swipe once it's clearly
        // sideways. Until then, leave it alone so vertical scroll and taps
        // behave normally.
        if (dx > HORIZONTAL_INTENT && dx > dy * 1.5) {
          didSwipe = true;
          e.preventDefault();
        }
      }, { passive: false });
      overlay.addEventListener('touchend', function (e) {
        if (!didSwipe) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) >= SWIPE_THRESHOLD) {
          if (dx < 0) goTo(current + 1);
          else goTo(current - 1);
          changedSlide = true;
        }
      }, { passive: true });
      overlay.addEventListener('click', function (e) {
        // Only cancel the click-through if an actual swipe changed the slide.
        // A plain tap (no slide change) always navigates to the PDP.
        if (changedSlide) {
          e.preventDefault();
          e.stopPropagation();
        }
        didSwipe = false;
        changedSlide = false;
      }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSwipe);
  } else {
    initMobileSwipe();
  }
  window.addEventListener('resize', initMobileSwipe, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initMobileSwipe, 100);
  });
})();